import { Routes } from '@angular/router';
import { routerSegments } from './consts/routes';
import { authenticatedGuard } from './guards/authenticated.guard';
import { PublicAccessDeniedPageComponent, PublicEmailVerificationPageComponent, PublicResetPasswordPageComponent } from '@auth';

export const routes: Routes = [
  {
    path: '',
    redirectTo: routerSegments.projects,
    pathMatch: 'full',
  },
  {
    path: routerSegments.projects,
    loadComponent: () => import('./components/layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authenticatedGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/project/project.routes').then((m) => m.projectRoutes),
      },
    ],
  },
  {
    path: routerSegments.accountDetails,
    loadComponent: () =>
      import('./components/layout/layout.component').then(
        (m) => m.LayoutComponent,
      ),
    canActivate: [authenticatedGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/account-details/account-details.component').then(
            (m) => m.AccountDetailsComponent,
          ),
      },
    ],
  },
  {
    path: routerSegments.logout,
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: routerSegments.resetPassword,
    component: PublicResetPasswordPageComponent,
  },
  {
    path: routerSegments.emailVerification,
    component: PublicEmailVerificationPageComponent,
  },
  {
    path: routerSegments.accessDenied,
    component: PublicAccessDeniedPageComponent,
  },
  {
    path: routerSegments.notFound,
    loadChildren: () => import('./pages/not-found/not-found.routes').then((m) => m.notFoundRoutes),
  },
  {
    path: '**',
    redirectTo: routerSegments.projects,
  },
];
